'use client';
import { hideModal } from '@/redux/navigationSlice';
import { Button, Stack } from '@mui/material';
import { MaterialIcon } from '@repo/ui';
import { useRouter } from 'next/navigation';
import { useDispatch } from 'react-redux';

/**
 * Renders a back to store body for a Modal component with redirect logic.
 *
 * @return {React.JSX.Element} The rendered ModalCancelBody component.
 */
export const BackToStoreBody = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const router = useRouter();
  return (
    <>
      <MaterialIcon icon="refresh" size={64} color="secondary" containerType="circle" />
      <Stack gap={2} width="100%" mt={2}>
        <Button
          onClick={() => {
            dispatch(hideModal());
            router.push('/back_to_store');
          }}
        >
          Volver a la tienda
        </Button>
        <Button variant="inverted" onClick={() => dispatch(hideModal())}>
          Cancelar
        </Button>
      </Stack>
    </>
  );
};
